import { render, staticRenderFns } from "./PlanIntervalSelector.vue?vue&type=template&id=2d8583d2&scoped=true"
import script from "./PlanIntervalSelector.vue?vue&type=script&lang=js"
export * from "./PlanIntervalSelector.vue?vue&type=script&lang=js"
import style0 from "./PlanIntervalSelector.vue?vue&type=style&index=0&id=2d8583d2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d8583d2",
  null
  
)

export default component.exports